import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { AnalyticsContext } from './AnalyticsProvider';

import logger from 'itrvl-logger';
const log = logger(__filename);

class TrackHistory extends PureComponent {
  static contextType = AnalyticsContext;

  static propTypes = {
    history: PropTypes.shape({
      listen: PropTypes.func.isRequired,
      location: PropTypes.object,
    }).isRequired,
  };

  componentDidMount() {
    log.trace('componentDidMount');
    if (this.context.analytics().page) {
      log.trace('page', this.props.history.location.pathname);
      this.context.analytics().page(this.props.history.location.pathname);
      this.listen(this.props, this.context.analytics());
    }
  }

  /* eslint-disable-next-line camelcase */
  UNSAFE_UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.history !== nextProps.history || this.context.analytics() !== nextContext.analytics()) {
      this.unlisten();
      if (nextContext.analytics()) {
        this.listen(nextProps, nextContext.analytics());
      }
    }
  }

  componentWillUnmount() {
    this.unlisten();
  }

  listen({ history }) {
    log.trace('listen');
    this.setState({
      unlisten: history.listen((location, _type) => {
        log.trace('page', location.pathname);
        this.context.analytics().page(location.pathname);
      }),
    });
  }

  unlisten() {
    if (this.state && this.state.unlisten) {
      log.trace('unlisten');
      this.state.unlisten();
      this.setState({ unlisten: undefined });
    }
  }

  render() {
    return <>{this.props.children}</>;
  }
}

export default withRouter(TrackHistory);
